<template>
  <BaseCell :align="align">
    <BaseText size="xs" :color="percentualColor">
      <component
        :is="component"
        class="money-cell"
        :width="`calc( ${width} * 0.75)`"
        :border-radius="borderRadius"
      >
        {{ percentualFormatted }}
      </component>
    </BaseText>
  </BaseCell>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BaseCell, BaseText } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import {
  NebraskaSizes,
  NebraskaColors
} from '@warrenbrasil/nebraska-tokens-web';
import { getCurrencyTextColor } from '@/modules/common/helpers/currency';

interface Props {
  width?: string;
  borderRadius?: string;
  percentualValue: number;
  percentualFormatted: string;
  align?: string;
  enableToggleMoney?: boolean;
  shouldChangeColorBasedOnValue?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  width: '100%',
  borderRadius: NebraskaSizes.Radius.x100,
  align: 'left',
  enableToggleMoney: false,
  shouldChangeColorBasedOnValue: true
});

const percentualColor = computed(() => {
  if (!props.shouldChangeColorBasedOnValue)
    return NebraskaColors.elementPrimary;
  return getCurrencyTextColor(props.percentualValue);
});

const component = computed(() => {
  return props.enableToggleMoney ? Money : 'span';
});
</script>

<style lang="less" scoped>
.money-cell {
  display: inline-block;
}
</style>
